import React, { Component } from "react";
import { fire, auth } from "../../firebase/index";
import AuditTrail from "../../assets/img/tutorialimages/viewAuditTrailGuide.png";
import viewAuditTrailGuide1_Jap from "../../assets/img/tutorialimages/viewAuditTrailGuide1_Jap.png";
import viewAuditTrailGuide2_Jap from "../../assets/img/tutorialimages/viewAuditTrailGuide2_Jap.png";
import viewAuditTrailGuide3_Jap from "../../assets/img/tutorialimages/viewAuditTrailGuide3_Jap.png";
import LocalizedStrings from "react-localization";
let localizationStrings = new LocalizedStrings({
  en: {},
  ja: {},
});

class AuditTrailGuide extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentLanguage: null,
    };

    this.getHelper = this.getHelper.bind(this);

    //? all function
  }

  async componentWillMount() {
    if (auth.currentUser !== null) {
      await fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          if (snapshot.exists()) {
            this.setState({
              currentLanguage: snapshot.val(),
            });
          }
        });
    }
  }

  getHelper() {
    if (this.state.currentLanguage === "en") {
      return (
        <div
          style={{
            width: "80%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <img
            className="imgStyle"
            src={AuditTrail}
            alt="AuditTrail"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
        </div>
      );
    } else if (this.state.currentLanguage === "ja") {
      return (
        <div
          style={{
            width: "80%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <img
            className="imgStyle"
            src={viewAuditTrailGuide1_Jap}
            alt="viewAuditTrailGuide1_Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={viewAuditTrailGuide2_Jap}
            alt="viewAuditTrailGuide2_Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={viewAuditTrailGuide3_Jap}
            alt="viewAuditTrailGuide3_Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
        </div>
      );
    } else if (this.state.currentLanguage === "es") {
      return (
        <div
          style={{
            width: "80%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <img
            className="imgStyle"
            src={AuditTrail}
            alt="AuditTrail"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
        </div>
      );
    }
  }
  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    return this.getHelper();
  }
}

export default AuditTrailGuide;
